import { Attachments } from './Attachments';
import { DropOverlay } from './DropOverlay';
import { DropZone } from './DropZone';
import { Editor } from './Editor';
import { FormatRibbon } from './FormatRibbon';
import {
  AttachFilesAction,
  AttachNativeMediaAction,
  CloseReplyAction,
  DiscardDraftAction,
  ToggleFormatAction,
} from './InputActions';
import { Layout } from './Layout';
import { Root } from './Root';
import { SendAction } from './SendAction';

export const Input = {
  Root,
  Layout,
  DropOverlay,
  DropZone,
  FormatRibbon,
  Editor,
  Attachments,
  AttachFilesAction,
  AttachNativeMediaAction,
  ToggleFormatAction,
  CloseReplyAction,
  DiscardDraftAction,
  SendAction,
};
